import { AerialState } from 'lib/generated/proto/aerial_interfaces/msg/AerialState';
import { FlightMode_ModeEnum } from 'lib/generated/proto/aerial_interfaces/msg/FlightMode';
import { PositionQuality_FixTypeEnum } from 'lib/generated/proto/aerial_interfaces/msg/PositionQuality';

// ─── Helpers ─────────────────────────────────────────────────────────────────

export function aerialFlightModeToString(mode: FlightMode_ModeEnum): string {
  switch (mode) {
    case FlightMode_ModeEnum.MODE_UNKNOWN:
      return 'Unknown';
    case FlightMode_ModeEnum.MODE_DISARMED:
      return 'Disarmed';
    case FlightMode_ModeEnum.MODE_ARMED:
      return 'Armed';
    case FlightMode_ModeEnum.MODE_TAKEOFF:
      return 'Taking Off';
    case FlightMode_ModeEnum.MODE_HOVERING:
      return 'Hovering';
    case FlightMode_ModeEnum.MODE_FLYING:
      return 'Flying';
    case FlightMode_ModeEnum.MODE_MISSION:
      return 'Mission';
    case FlightMode_ModeEnum.MODE_RTL:
      return 'Return to Launch';
    case FlightMode_ModeEnum.MODE_LANDING:
      return 'Landing';
    case FlightMode_ModeEnum.MODE_LANDED:
      return 'Landed';
    default:
      return 'Unknown';
  }
}

export function fixTypeToString(fixType: PositionQuality_FixTypeEnum): string {
  switch (fixType) {
    case PositionQuality_FixTypeEnum.FIX_UNKNOWN:
      return 'Unknown';
    case PositionQuality_FixTypeEnum.FIX_NO_FIX:
      return 'No Fix';
    case PositionQuality_FixTypeEnum.FIX_2D:
      return '2D Fix';
    case PositionQuality_FixTypeEnum.FIX_3D:
      return '3D Fix';
    case PositionQuality_FixTypeEnum.FIX_DGPS:
      return 'DGPS';
    case PositionQuality_FixTypeEnum.FIX_RTK_FLOAT:
      return 'RTK Float';
    case PositionQuality_FixTypeEnum.FIX_RTK_FIXED:
      return 'RTK Fixed';
    default:
      return 'Unknown';
  }
}

export function isAerialFlying(state: AerialState): boolean {
  return state.flying || [
    FlightMode_ModeEnum.MODE_TAKEOFF,
    FlightMode_ModeEnum.MODE_HOVERING,
    FlightMode_ModeEnum.MODE_FLYING,
    FlightMode_ModeEnum.MODE_MISSION,
    FlightMode_ModeEnum.MODE_RTL,
    FlightMode_ModeEnum.MODE_LANDING,
  ].includes(state.flight_mode?.mode ?? FlightMode_ModeEnum.MODE_UNKNOWN);
}

export function canAerialLand(state: AerialState): boolean {
  return isAerialFlying(state) && state.flight_mode?.mode !== FlightMode_ModeEnum.MODE_LANDING;
}

export function canAerialTakeoff(state: AerialState): boolean {
  const mode = state.flight_mode?.mode ?? FlightMode_ModeEnum.MODE_UNKNOWN;
  return !isAerialFlying(state) && (
    mode === FlightMode_ModeEnum.MODE_ARMED ||
    mode === FlightMode_ModeEnum.MODE_LANDED ||
    mode === FlightMode_ModeEnum.MODE_DISARMED
  );
}
